/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import { useI18nState } from '../../../stores/settings/language-context';
import ProfileArrowIcon from '../../../common/icons/header-icon';
import CollapseIcon from '../../../common/icons/collapase-icon';
import {
  useSettingContext,
  useSettingDispatch
} from '../../../contexts/settings/setting-menu-header-context';
import LogoutButton from '../../../auth0/logout';
import './header.scss';
import avatar from '../../../common/images/Avatar.png';
import {
  faarrowrightclassicregular,
  fabellclassicregular,
  famagnifyingglassclassicregular,
  famessageclassicregular,
  fauserclassicregular,
  FontAwesomeIcon,
  GrcPopover,
  GrcTextBox,
  IconProp
} from '@grc/ui-package';
import SettingsMenu from '../side-nav/settings-menu/settings-menu';
import { headerPopoverWidth } from '../../../common/constants/constants';
import { MenuItems } from '../side-nav/side-menu/menu';
import { useCustomerPortalGlobalStore } from '../../../stores/customer-portal-global-store';

const Header = () => {
  const [isProfilePopOverVisible, setIsProfilePopOverVisible] = useState(false);
  const [isGlobalSearchVisible, setIsGlobalSearchVisible] = useState(false);
  const { localeData } = useI18nState();
  const { setIsSettingsDrawerOpened } = useSettingDispatch();
  const { isSettingsDrawerOpened } = useSettingContext();
  const [selectedMenu] = useCustomerPortalGlobalStore(
    store => store.menu.selectedMenu
  );
  // Selecting the whole `menu` slice and patching it via the root-merge
  // setter (same pattern as settings-menu.tsx), rather than
  // useSetCustomerPortalGlobalStorePath, for consistency with the rest of
  // this component.
  const [menuState, setGlobalStore] = useCustomerPortalGlobalStore(
    store => store.menu
  );
  const isSideNavOpened = menuState.isSideNavOpened;
  const setIsSideNavOpened = (value: boolean) => {
    setGlobalStore({ menu: { ...menuState, isSideNavOpened: value } });
  };

  const getParentMenuText = (menuText: string) => {
    const menuItem = MenuItems.find(item => item.text === menuText);
    if (menuItem && menuItem.parentId !== 0) {
      const parentItem = MenuItems.find(item => item.id === menuItem.parentId);
      return parentItem ? parentItem.text : menuText;
    }
    return menuText;
  };

  const parentMenuText = getParentMenuText(selectedMenu);

  return (
    <>
      <div className="header-layout">
        <nav className="navbar navbar-expand-lg navbar-light bg-white">
          <span
            className={
              !isSideNavOpened
                ? 'expand-icon  cursor-p'
                : '  collpase-icon cursor-p'
            }
            onClick={() => {
              setIsSideNavOpened(!isSideNavOpened);
            }}
          >
            <CollapseIcon />
          </span>
          <a className="navbar-brand mx-2">{parentMenuText}</a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <div className="d-flex mx-3">
              <div className="d-flex">
                {isGlobalSearchVisible && (
                  <div className="global-search">
                    <GrcTextBox placeholder={localeData.Search} />
                  </div>
                )}
                <div
                  className="header-action mr-2 cursor-p"
                  onClick={() => {
                    setIsGlobalSearchVisible(prevState => !prevState);
                  }}
                >
                  <FontAwesomeIcon
                    className="header-icon"
                    icon={famagnifyingglassclassicregular as IconProp}
                    fontSize={18}
                  />
                </div>
              </div>

              <div className="header-action mx-2">
                <FontAwesomeIcon
                  className="header-icon"
                  icon={famessageclassicregular as IconProp}
                  fontSize={20}
                />
              </div>
              <div className="header-action mx-2">
                <FontAwesomeIcon
                  className="header-icon"
                  icon={fabellclassicregular as IconProp}
                  fontSize={20}
                />
              </div>
            </div>

            <div className="navbar-nav mr-auto">
              <div className="user-profile">
                <img src={avatar} alt="" />
              </div>
              <div className="user-details">
                <div className="user-name">{'Wilson Culhane'}</div>
                <div className="user-designation">{'Admin'}</div>
              </div>
              <ul className="navbar-nav mr-auto">
                <li className="nav-item dropdown cursor-p d-flex align-items-center">
                  <div>
                    <div
                      id="profile"
                      onClick={() => {
                        isProfilePopOverVisible
                          ? setIsProfilePopOverVisible(false)
                          : setIsProfilePopOverVisible(true);
                      }}
                    >
                      <ProfileArrowIcon />
                    </div>
                    <GrcPopover
                      target="#profile"
                      className="settings-popover"
                      visible={isProfilePopOverVisible}
                      onHiding={() => {
                        setIsProfilePopOverVisible(false);
                      }}
                      width={headerPopoverWidth}
                    >
                      <div className="profile-popover-panel">
                        <div className="profile-menu-list">
                          <div className="profile-menu-item cursor-p">
                            <FontAwesomeIcon
                              icon={fauserclassicregular as IconProp}
                              fontSize={18}
                            />
                            <span>{localeData.ViewProfile}</span>
                          </div>
                          <div
                            className="profile-menu-item cursor-p"
                            onClick={() => {
                              setIsProfilePopOverVisible(false);
                              setIsSettingsDrawerOpened(
                                (prevState: boolean) => !prevState
                              );
                            }}
                          >
                            <FontAwesomeIcon
                              icon={fauserclassicregular as IconProp}
                              fontSize={18}
                            />
                            <span>{localeData.Themes}</span>
                          </div>
                          <div
                            className="profile-menu-item cursor-p"
                            onClick={() => {
                              setIsProfilePopOverVisible(false);
                              setIsSettingsDrawerOpened(
                                (prevState: boolean) => !prevState
                              );
                            }}
                          >
                            <FontAwesomeIcon
                              icon={fauserclassicregular as IconProp}
                              fontSize={18}
                            />
                            <span>{localeData.Languages}</span>
                          </div>
                        </div>
                        <div className="profile-logout cursor-p">
                          <FontAwesomeIcon
                            className="profile-logout-arrow"
                            icon={faarrowrightclassicregular as IconProp}
                            fontSize={20}
                          />
                          <span className="profile-logout-button">
                            <LogoutButton />
                          </span>
                        </div>
                      </div>
                    </GrcPopover>
                  </div>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <a className="dropdown-item" href="#">
                      Action
                    </a>
                    <a className="dropdown-item" href="#">
                      Another action
                    </a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="#">
                      Something else here
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      {isSettingsDrawerOpened && (
        <SettingsMenu setIsSettingsDrawerOpened={setIsSettingsDrawerOpened} />
      )}
    </>
  );
};

export default Header;
